import { createContext, type ReactNode, useContext } from 'react';

/** What the shared `ColorPicker` hands to the app's palette library (when one is provided). */
export interface ColorLibraryProps {
  /** Accessible name of the picker the library belongs to. */
  label: string;
  /** The color now in the field (a valid `#rrggbb`), else `null`. */
  value: string | null;
  /** The workspace the color is for: its shared palettes are listed first. */
  workspaceId?: string | undefined;
  disabled?: boolean;
  /** The ONE explicitly chosen color: the picker applies it exactly like a swatch click. */
  onPick: (color: string) => void;
}

type RenderLibrary = (props: ColorLibraryProps) => ReactNode;

const ColorLibraryContext = createContext<RenderLibrary | null>(null);

/** The app provides the palette library here (a render function), so `shared` stays free of
 *  product code. */
export const ColorLibraryProvider = ColorLibraryContext.Provider;

export function useColorLibrary(): RenderLibrary | null {
  return useContext(ColorLibraryContext);
}
